var Backbone, EmailFormUSUserContactInfoView, GrouponValidate, SupportUserContactInfoTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GrouponValidate = require("../../../../../groupon/frontend/validate");

Backbone = require('backbone');

Backbone.$ = $;

SupportUserContactInfoTemplate = require('../../../../user_contact_info.html.mustache');

EmailFormUSUserContactInfoView = (function(superClass) {
  extend(EmailFormUSUserContactInfoView, superClass);

  function EmailFormUSUserContactInfoView() {
    return EmailFormUSUserContactInfoView.__super__.constructor.apply(this, arguments);
  }

  EmailFormUSUserContactInfoView.prototype.tagName = 'li';

  EmailFormUSUserContactInfoView.prototype.className = 'requestedFields';

  EmailFormUSUserContactInfoView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.model = this.options.model;
    this.isInputCompulsory = this.model.required;
    return this.template = SupportUserContactInfoTemplate;
  };

  EmailFormUSUserContactInfoView.prototype.events = {
    'change #contactOnlyByMail': 'onContactOnlyByMail',
    'keyup #contact_phone': 'enableDisableSubmitButton',
    'keyup #contact_email': 'enableDisableSubmitButton'
  };

  EmailFormUSUserContactInfoView.prototype.render = function() {
    this.$el.append(toHtml(this.template, {}, this.I18nScope));
    return this.changeDescriptionText();
  };

  EmailFormUSUserContactInfoView.prototype.enableDisableSubmitButton = function() {
    return this.options.validateEmailForm.call();
  };

  EmailFormUSUserContactInfoView.prototype.changeDescriptionText = function() {
    return $('#ticket_description').text(I18n.translate('js.modules.support.additional_details_example'));
  };

  EmailFormUSUserContactInfoView.prototype.contactOnlyByMail = function() {
    return $('#contactOnlyByMail').is(':checked');
  };

  EmailFormUSUserContactInfoView.prototype.onContactOnlyByMail = function() {
    $('#validateContactPhone').css('display', 'none');
    if (this.contactOnlyByMail()) {
      this.getUserPhoneElement().attr('disabled', 'disabled');
      this.getUserPhoneElement().val("");
      this.getUserEmailElement().css('display', 'block');
      if (typeof currentUser !== "undefined" && currentUser !== null) {
        this.getUserEmailElement().val(typeof currentUser !== "undefined" && currentUser !== null ? currentUser.email : void 0);
      } else {
        this.getUserEmailElement().val($('#tcktUsermail').val());
      }
      $(".stepThreeLabel #contactOnlyByPhonenumberMandatory").css('display', 'none');
      $("#contactOnlyByMailMandatory").css('display', 'inline');
      $(".inputField#contact_phone").val('');
    } else {
      this.getUserPhoneElement().removeAttr('disabled');
      this.getUserEmailElement().css('display', 'none');
      $('#validateContactEmail').css('display', 'none');
      $("#contactOnlyByMailMandatory").css('display', 'none');
      $(".stepThreeLabel #contactOnlyByPhonenumberMandatory").css('display', 'inline');
      $(".inputField#contact_email").val('');
    }
    return this.options.validateEmailForm.call();
  };

  EmailFormUSUserContactInfoView.prototype.validateContactEmail = function() {
    var email_id, ref, ref1;
    email_id = (ref = this.getUserEmailElement()) != null ? (ref1 = ref.val()) != null ? ref1.trim() : void 0 : void 0;
    if (GrouponValidate.email(email_id)) {
      $('#validateContactEmail').css('display', 'none');
      return true;
    } else {
      $('#validateContactEmail').css('display', 'block');
      return false;
    }
  };

  EmailFormUSUserContactInfoView.prototype.validateContactPhone = function() {
    var phoneNum, ref, ref1;
    phoneNum = (ref = this.getUserPhoneElement()) != null ? (ref1 = ref.val()) != null ? ref1.trim() : void 0 : void 0;
    if (GrouponValidate.phone(phoneNum)) {
      $('#validateContactPhone').css('display', 'none');
      return true;
    } else {
      $('#validateContactPhone').css('display', 'block');
      return false;
    }
  };

  EmailFormUSUserContactInfoView.prototype.populateInput = function(data) {
    var ref, ref1, ref2, ref3;
    data.user_given_email = (ref = this.getUserEmailElement()) != null ? (ref1 = ref.val()) != null ? ref1.trim() : void 0 : void 0;
    data.user_given_phone = (ref2 = this.getUserPhoneElement()) != null ? (ref3 = ref2.val()) != null ? ref3.trim() : void 0 : void 0;
    data.contact_only_email = this.contactOnlyByMail();
    return data.userContactInfoView = true;
  };

  EmailFormUSUserContactInfoView.prototype.isInputValid = function() {
    if (this.contactOnlyByMail()) {
      return this.validateContactEmail();
    } else {
      return this.validateContactPhone();
    }
  };

  EmailFormUSUserContactInfoView.prototype.getUserPhoneElement = function() {
    return this.$el.find('#contact_phone');
  };

  EmailFormUSUserContactInfoView.prototype.getUserEmailElement = function() {
    return this.$el.find('#contact_email');
  };

  EmailFormUSUserContactInfoView.prototype.isInputGiven = function() {
    var ref, ref1, ref2, ref3;
    if (this.contactOnlyByMail()) {
      return ((ref = this.getUserEmailElement()) != null ? (ref1 = ref.val()) != null ? ref1.trim().length : void 0 : void 0) > 0;
    } else {
      return ((ref2 = this.getUserPhoneElement()) != null ? (ref3 = ref2.val()) != null ? ref3.trim().length : void 0 : void 0) > 0;
    }
  };

  return EmailFormUSUserContactInfoView;

})(Backbone.View);

module.exports = EmailFormUSUserContactInfoView;

//# sourceMappingURL=data:application/json;base64,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
